import Config from '@config';
import initializeEquipmentTypeApi from '@gasbi/shared/common/features/equipmentType/equipmentTypeApi';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  equipmentTypeApi,
  useCreateEquipmentTypeMutation,
  useUpdateEquipmentTypeMutation,
  useGetEquipmentTypesIInfiniteQuery,
} = initializeEquipmentTypeApi(Config.VITE_API_URL, axiosBaseQuery);
